<template>
<div class="chapter">
<div class="inner_page">
<p style="page-break-before: always; text-align: center; text-indent: 0">AUTHOR’S NOTE</p>
<p class="section-break">––––––––</p><div class="decoration-scene-break"><div class="decoration-scene-break-inner"><img alt="image" class="decoration-scene-break" src="d2d_images/scene_break.png"/></div></div>
<p style="text-align: center; text-indent: 0"><span style="font-size: small">Thank you for picking up </span><span style="font-weight: bold">Haunted Castle, Hanging Doll, and Honey Ham</span></p>
<p style="font-weight: bold; text-align: center; text-indent: 0">(Sadie Silver Mystery #8)</p>
<p class="section-break">––––––––</p><div class="decoration-scene-break"><div class="decoration-scene-break-inner"><img alt="image" class="decoration-scene-break" src="d2d_images/scene_break.png"/></div></div>
<p style="font-size: small; text-align: center; text-indent: 0">This series is a cozy mystery with clean romance and some pet paranormal elements recommended for age 13 and up. </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c002.vue?1e8d9cc9